import { ComponentType } from '@angular/cdk/overlay'
import { OnboardingCategoriesEnum } from '../../../domain/models/onboarding-categories.enum'
import { WhereToStartComponent } from '../../categories/where-to-start/where-to-start.component'
import { CandidatesInProjectComponent } from '../../categories/candidates-in-project/candidates-in-project.component'
import { BaseOnboardingCategoryDirective } from '../../categories/base-onboarding-category/base-onboarding-category.directive'
import { ActionsWithCandidatesComponent } from '../actions-with-candidates/actions-with-candidates.component'
import { FunnelComponent } from '../funnel/funnel.component'
import { StatisticsAndAnalyticsComponent } from '../statistics-and-analytics/statistics-and-analytics.component'
import { UserRightsComponent } from '../user-rights/user-rights.component'

export const CategoriesToComponentsMap: Record<OnboardingCategoriesEnum, ComponentType<BaseOnboardingCategoryDirective>> = {
  [OnboardingCategoriesEnum.whereToStart]: WhereToStartComponent,
  [OnboardingCategoriesEnum.candidatesInProject]: CandidatesInProjectComponent,
  [OnboardingCategoriesEnum.actionsWithCandidates]: ActionsWithCandidatesComponent,
  [OnboardingCategoriesEnum.funnel]: FunnelComponent,
  [OnboardingCategoriesEnum.statisticsAndAnalytics]: StatisticsAndAnalyticsComponent,
  [OnboardingCategoriesEnum.userRights]: UserRightsComponent
}
